import {
  TableState,
} from "../../shared/components/TableState";
import type {
  useSuppliersWorkspace,
} from "./useSuppliersWorkspace";

export function SupplierHistory({ model }: { model: ReturnType<typeof useSuppliersWorkspace> ;}) {
  const { supplierTab, qualificationCase, qualificationLabels } = model;
  return (<>{supplierTab === "history" ? (
    (
      qualificationCase?.decision_history ??
      qualificationCase?.decisionHistory ??
      []
    ).length ? (
      <div className="data-table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Karar</th>
              <th>Sürüm</th>
              <th>Gerekçe</th>
              <th>Zaman</th>
            </tr>
          </thead>
          <tbody>
            {(
              qualificationCase?.decision_history ??
              qualificationCase?.decisionHistory ??
              []
            ).map((item, index) => (
              <tr key={item.id}>
                <td>
                  {
                    qualificationLabels[
                    "decision" in item
                      ? item.decision
                      : item.status
                    ]
                  }
                </td>
                <td>
                  {"decision_version" in item
                    ? item.decision_version
                    : index + 1}
                </td>
                <td>{item.reason}</td>
                <td>
                  {new Date(
                    "decided_at" in item
                      ? item.decided_at
                      : item.effectiveFrom,
                  ).toLocaleString("tr-TR")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <TableState
        title="Geçmiş kaydı yok"
        description="Tedarikçiyle ilgili doğrulanmış kararlar burada görünür."
      />
    )
  ) : null}</>);
}
